import React from 'react';

export default function Footer() {
  return (
    <footer>
      <div className="container">
        <p>&copy; Bopp Studio 2021. All Rights Reserved.</p>
        <ul className="list-inline">
          <li className="list-inline-item">
            <a href="/terms">Terms</a>
          </li>
          <li className="list-inline-item"> | </li>
          <li className="list-inline-item">
            <a href="/terms#pp">Privacy Policy</a>
          </li>
        </ul>
      </div>
    </footer>
  );
}
